var _defs, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "AnimatedIcon__icon",
    width: 96,
    height: 96,
    preserveAspectRatio: "xMinYMin",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    "data-js-controller": "FastForwardIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "fastForwardIconClipPath"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "var(--blendBackground)",
    "data-js-target-list": "FastForwardIcon.firstBackArrows",
    "data-js-bbox": "firstHiddenArrow"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    transform: "translate(-42, 0)",
    fill: "var(--blendBackground)",
    "data-js-target-list": "FastForwardIcon.secondBackArrows",
    "data-js-bbox": "secondHiddenArrow"
  })), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fastForwardIconArrow",
    d: "M19.15 31.36l21.53 15.15a2 2 0 0 1 0 3.27L19.15 64.93A2 2 0 0 1 16 63.29V33a2 2 0 0 1 3.15-1.64z"
  }))), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "#80E9FF",
    "data-js-target": "FastForwardIcon.firstHiddenArrow",
    style: {
      visibility: "hidden"
    }
  }), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    transform: "translate(-42, 0)",
    fill: "#80E9FF",
    "data-js-target": "FastForwardIcon.secondHiddenArrow",
    style: {
      visibility: "hidden"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "#80E9FF",
    "data-js-target-list": "FastForwardIcon.firstBackArrows"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "#80E9FF",
    "data-js-target-list": "FastForwardIcon.secondBackArrows",
    style: {
      opacity: 0
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    transform: "translate(14, 0)",
    fill: "#7A73FF",
    "data-js-target-list": "FastForwardIcon.firstFrontArrows"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "#7A73FF",
    "data-js-target-list": "FastForwardIcon.secondFrontArrows",
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fastForwardIconClipPath)"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    transform: "translate(14, 0)",
    fill: "#0048E5",
    "data-js-target-list": "FastForwardIcon.firstFrontArrows"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#fastForwardIconArrow",
    fill: "#0048E5",
    "data-js-target-list": "FastForwardIcon.secondFrontArrows",
    style: {
      opacity: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.41f1113bc050a1de6649028a2fb89371.svg";
export { ForwardRef as ReactComponent };